import { memo } from "react";
import { Provider } from "react-redux";
import type { Widgets } from "../../../../api/types/dashboardsTypes";
import { WidgetType } from "../../../../api/types/dashboardsTypes";
import { store } from "../../reporting/sv/store/store";
import FilterWidget from "./filter/FilterWidget";
import SmartViewWidget from "./smartview/SmartViewWidgetComponent";

const WidgetRenderer = memo(function WidgetRenderer({ widget }: { widget: Widgets }) {
  switch (widget.type) {
    case WidgetType.SmartView:
      return (
        <Provider store={store}>
          <SmartViewWidget key={widget.widgetId} widget={widget} />
        </Provider>
      );
    case WidgetType.Filter:
      return <FilterWidget key={widget.widgetId} widget={widget} />;
    default:
      return <div>Unknown widget type: {widget}</div>;
  }
});

export default WidgetRenderer;
